import React, { useState } from 'react'

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import { Chip, FormControl, Input, InputLabel } from '@mui/material'

import { input } from '@albacross/frontend-utils'

import AutoCompletePopup from './AutoCompletePopup'

type AutoCompleteProps = {
  options: any
  value: any
  onChange: (...args: any[]) => any
  fullWidth?: boolean
  label?: string
  multiple?: boolean
}

const AutoComplete = ({
  options,
  value,
  onChange,
  fullWidth = true,
  label = '',
  multiple = true,
}: AutoCompleteProps) => {
  const [filter, setFilter] = useState('')
  const [open, setOpen] = useState(false)

  const selected = value || []

  const handleClose = (e: any) => {
    e.stopPropagation()
    setOpen(false)
  }

  const handleChange = (option: any) => {
    const current = [...(value || [])]
    const index = current.indexOf(option)

    let newValue
    if (index !== -1) {
      newValue = current.filter((_, i) => i !== index)
    } else {
      newValue = multiple ? [...current, option] : [option]
    }

    onChange(newValue)
    setOpen(false)
  }

  return (
    <div>
      <FormControl fullWidth={fullWidth} onClick={() => setOpen(true)}>
        <InputLabel>{label}</InputLabel>
        <Input endAdornment={<ArrowDropDownIcon />} placeholder={label} />
      </FormControl>
      {selected.map((key: any) => (
        <Chip
          key={key}
          label={options.find((option: any) => option.value === key)?.label}
          onDelete={() => handleChange(key)}
          sx={{
            mt: '10px',
            mr: '5px',
            height: 'auto',
            '& .MuiChip-label': { px: '15px', py: '6px', whiteSpace: 'initial' },
          }}
        />
      ))}
      <AutoCompletePopup
        filter={filter}
        onChange={handleChange}
        onClose={handleClose}
        onFilterChange={(e: any) => setFilter(e.target.value)}
        open={open}
        options={options}
        selected={selected}
      />
    </div>
  )
}

export default input([])(AutoComplete)
